// app/javascript/landing/pages/HomePage.tsx
import React from "react";
import { Hero } from "../sections/Hero";
import { Services } from "../sections/Services";
import { WorkProcessSection } from "../sections/WorkProcessSection";
import { Technologies } from "../sections/Technologies";
import { PortfolioTeaser } from "../sections/PortfolioTeaser";
import { ClientsStrip } from "../sections/ClientsStrip";
import { AdoptionBanner } from "../sections/AdoptionBanner";
import { ImmersiveBenefitsSection } from "../sections/ImmersiveBenefitsSection";
import { ImmersiveIntroSection } from "../sections/ImmersiveIntroSection";
import type { RouteKey } from "../components/Navbar";

type HomePageProps = {
  onNavigate?: (route: RouteKey, href: string) => void;
};

export function HomePage({ onNavigate }: HomePageProps) {
  return (
    <main className="pb-48 md:pb-64 space-y-48">
      <Hero onNavigate={onNavigate} />
      <ImmersiveIntroSection />
      <AdoptionBanner />
      <Services />
      <WorkProcessSection />
      <div>
        <ImmersiveBenefitsSection />
        <Technologies />
      </div>
      <PortfolioTeaser onNavigate={onNavigate} />
      <ClientsStrip />
    </main>
  );
}

// import { Productivity } from "../sections/Productivity";
// import { Contact } from "../sections/Contact";

{
  /* 
      <Contact /> */
}
